import ImageGalleryModal from "../pages/modals/image-gallery-modal";
import UploadProductModal from "../pages/modals/upload-product-modal";
import UploadSupplierProductModal from "../pages/modals/upload-supplier-product-modal";
export enum ModalID {
  UploadSupplierProduct = 1,
  ImageGallery = 2,
  UploadProduct = 3
}

export const ModalComponents: Record<ModalID, React.ComponentType<any>> = {
  [ModalID.UploadSupplierProduct]: UploadSupplierProductModal,
  [ModalID.ImageGallery]: ImageGalleryModal,
  [ModalID.UploadProduct]: UploadProductModal
};
